module.exports = __webpack_public_path__ + "img/IDCard-hold.2f7a1118.png";